export default "__VITE_ASSET__D8J9kVng__"